import styled from 'styled-components'

export const ColorWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > div {
    display: flex;
  }
`

export const ColorBox = styled.div`
  &&& {
    width: 24px;
    height: 24px;
    border-radius: 2px;
    background-color: ${props => props.color};
    margin: 5px;
    flex-basis: calc(100% / 6);
    padding: 3px 0 0 2px;
    cursor: pointer;

    .icon {
      margin: 0;
    }
  }
`

export const ActiveChoiceWrapper = styled.div`
  width: 35px;
  height: 35px;
  border: 1px solid #d8dadb;
  background-color: #fff;
  border-radius: 4px;

  * {
    cursor: pointer;
  }
`
